<script setup lang="ts">
import ChatLogSkeleton from '@/views/apps/chat-matrix-fast/components/chat-log/ChatLogSkeleton.vue'

withDefaults(defineProps<{
  showHideButton?: boolean
  showBackButton?: boolean
}>(), {
  showHideButton: false,
  showBackButton: false,
})

const emit = defineEmits<{
  (e: 'hideChat'): void
  (e: 'back'): void
}>()
</script>

<template>
  <div class="chat-panel-skeleton d-flex flex-column h-100">
    <div class="chat-panel-skeleton-header d-flex align-center">
      <IconBtn
        v-if="showBackButton"
        class="me-4"
        @click="emit('back')"
      >
        <VIcon icon="ri-arrow-left-line" />
      </IconBtn>
      <VSkeletonLoader
        type="avatar"
        width="40"
        height="40"
        class="chat-panel-skeleton-avatar me-4 flex-shrink-0"
      />
      <div class="chat-panel-skeleton-text d-flex flex-column justify-center flex-grow-1 overflow-hidden">
        <VSkeletonLoader
          type="text"
          width="200"
          height="16"
          class="chat-panel-skeleton-line"
        />
        <VSkeletonLoader
          type="text"
          width="120"
          height="12"
          class="chat-panel-skeleton-line"
        />
      </div>
      <VBtn
        v-if="showHideButton"
        icon="ri-play-fill"
        variant="text"
        color="primary"
        class="ms-2"
        aria-label="Скрыть чат"
        @click="emit('hideChat')"
      />
    </div>
    <VDivider />
    <div class="flex-grow-1 chat-panel-skeleton-log">
      <div class="chat-log pa-5">
        <ChatLogSkeleton />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chat-panel-skeleton {
  background-color: rgb(var(--v-theme-background));
}

.chat-panel-skeleton-header {
  min-block-size: 64px;
  max-block-size: 64px;
  overflow: hidden;
  padding-block: 12px;
  padding-inline: 1.25rem;
  background-color: rgb(var(--v-theme-background));
}

.chat-panel-skeleton-avatar {
  width: 40px !important;
  height: 40px !important;
  min-height: 40px !important;
  border-radius: 50% !important;
  overflow: hidden;

  :deep(.v-skeleton-loader__bone) {
    width: 40px !important;
    height: 40px !important;
    border-radius: 50% !important;
  }
}

.chat-panel-skeleton-text {
  gap: 6px;
  min-width: 0;
}

.chat-panel-skeleton-line {
  max-width: 100%;
  height: 16px !important;
  min-height: 0 !important;
  margin: 0 !important;

  &:last-child {
    height: 12px !important;
  }

  :deep(.v-skeleton-loader__bone) {
    margin: 0 !important;
    height: 100% !important;
  }
}

.chat-panel-skeleton-log {
  overflow: hidden;
}
</style>
